import { useNormalClickHandler } from '@/common/hooks/useNormalClickHandler'
import { Box, Flex, Heading } from '@chakra-ui/react'
import React, { useContext } from 'react'
import { Meeting_Step_Type_Enum } from '@gql'
import { MeetingContext } from '../contexts/MeetingContext'
import MeetingStepAids from './MeetingStepAids'
import MeetingStepNumber from './MeetingStepNumber'

interface Props {
  index: number
  stepId: string
  title: string
  type: Meeting_Step_Type_Enum
  // The aids are for a meeting being held, not one being read (#136)
  showAids: boolean
  current: boolean
  onStepClick?(): void
  children: React.ReactNode
}

export default function MeetingStepLayout({
  index,
  stepId,
  title,
  type,
  showAids,
  current,
  onStepClick,
  children,
}: Props) {
  const { handleScrollToStep, path } = useContext(MeetingContext)!
  const anchor = `step-${stepId}`

  const handleStepLinkClick = useNormalClickHandler(() =>
    handleScrollToStep(stepId)
  )

  return (
    <>
      <Flex alignItems="center" position="relative">
        {/* Anchor */}
        <Box id={anchor} transform="translateY(-100px)" />

        <MeetingStepNumber
          index={index}
          current={current}
          mr={4}
          position={{ base: 'static', lg: 'absolute' }}
          left="-45px"
          onStepClick={onStepClick}
        />
        <Heading as="h2" size="md">
          <a href={`${path}#${anchor}`} onClick={handleStepLinkClick}>
            {title}
          </a>
        </Heading>
        {/* What facilitation, secretary and participants do here (#136) */}
        {showAids && <MeetingStepAids type={type} />}
      </Flex>
      <Box pt={7} pb={32}>
        {children}
      </Box>
    </>
  )
}
